import { Box } from '@material-ui/core';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getLottieById } from '../../../../modules/user/pages/activities/activitiesActions';
import LottieControl from '../../lottie/lottie';
import DOMPurify from 'dompurify';
import { BASE_S3 } from 'config/consts';

let FeedbackContent = function (props) {
  useEffect(() => {
    if (props.lottieId) props.getLottieById(props.lottieId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.lottieId]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      style={{ width: '100%', height: '95vh' }}
    >
      {props.lottie.json ? (
        <LottieControl loop={false} animation={props.lottie.json} />
      ) : null}
      <div
        style={{ maxWidth: '35em' }}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(props.htmlFeedback),
        }}
      />
      {props.trophyImage ? (
        <img
          src={`${BASE_S3}/${props.trophyImage}`}
          alt={props.trophyDescription || 'Troféu'}
          style={{ maxWidth: '200px', marginTop: '1.5em' }}
        />
      ) : null}
      {props.trophyDescription ? (
        <p style={{ marginTop: '0.5em', textAlign: 'center', fontWeight: 'bold' }}>
          {props.trophyDescription}
        </p>
      ) : null}
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getLottieById,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackContent);
